import { z } from 'zod'

export const LoyaltyColor = ['primary', 'secondary'] as const
export const LoyaltyColorSchema = z.enum(LoyaltyColor)
export type LoyaltyColorType = (typeof LoyaltyColor)[number]
